import { hydrateRoot, createRoot, type Root } from "react-dom/client";
import type { OnRenderClientAsync } from "vike/types";
import { PageShell } from "./PageShell";

let root: Root | null = null;

const onRenderClient: OnRenderClientAsync = async (
  pageContext,
): ReturnType<OnRenderClientAsync> => {
  const { Page } = pageContext;
  if (!Page) throw new Error("No page component found.");

  const container = document.getElementById("root");
  if (!container) throw new Error("#root not found.");

  const tree = (
    <PageShell pageContext={pageContext}>
      <Page />
    </PageShell>
  );

  if (pageContext.isHydration) {
    root = hydrateRoot(container, tree);
  } else {
    if (!root) root = createRoot(container);
    root.render(tree);
  }
};

export default onRenderClient;
